import { LocalizationWithComponent } from '@/components/blocks/LocalizationWithComponent';
import { NoStoreFounPanelSX } from '@/components/content/StoreLocator/styles/StoreLocatorNoStoreFoundPanel/NoStoresFoundPanel';
import { useLocalization } from '@/data/Localization';
import { Box, Grid, Typography } from '@mui/material';
import { CDN_BASE_URL } from 'shared/custom/constants/commonConstants';

type Props = {
	searchText: string;
};

const boldComponent = [<b key="bold" />];

export const HeaderNoStoresFoundPanel = ({ searchText }: Props) => {
	const localization = useLocalization('SearchStores');
	const imgUrl = `${CDN_BASE_URL}/assets/img/store-not-found.png`;

	return (
		<Grid>
			<Typography sx={NoStoreFounPanelSX.noFoundMessage}>
				<LocalizationWithComponent
					text={localization.noStoreFoundView.noFoundMessage.t({ searchText })}
					components={boldComponent}
				/>
			</Typography>
			<Grid container wrap="nowrap" sx={NoStoreFounPanelSX.noFoundImproveMessageContainer}>
				<img alt={localization.noStoreFoundView.storeNotFound.t()} src={imgUrl} />
				<Box sx={NoStoreFounPanelSX.noFoundImproveMessage}>
					<Typography sx={NoStoreFounPanelSX.searchForMessage}>
						<LocalizationWithComponent
							text={localization.noStoreFoundView.searchFor.t()}
							components={boldComponent}
						/>
					</Typography>
					<Typography>{localization.noStoreFoundView.improveYourSearch.t()}</Typography>
				</Box>
			</Grid>
		</Grid>
	);
};
